(function(){
  var cd=document.getElementById('pa-cd'), overlay=document.getElementById('pa-cd-overlay');
  if(!cd) return;
  var body=document.body, itemsEl=document.getElementById('pa-cd-items'), emptyEl=document.getElementById('pa-cd-empty'), foot=document.getElementById('pa-cd-foot');
  var ALL='/products/voltguard-4-in-1-jump-starter-tire-inflator';
  var VARIANT=cd.getAttribute('data-variant')||'';
  var justAdded=false, recalced=false;
  var CHK='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  function R(c){return Math.round(c/100);}
  function rand(n){return 'R'+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function esc(s){return (s||'').replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  function isOpen(){return body.classList.contains('pa-cd-open');}
  function open(){body.classList.add('pa-cd-open');cd.setAttribute('aria-hidden','false');}
  function close(){body.classList.remove('pa-cd-open');cd.setAttribute('aria-hidden','true');}
  function $(id){return document.getElementById(id);}

  function render(cart){
    var cnt=$('cart-count'); if(cnt) cnt.textContent=cart.item_count;
    if(!cart.items.length){
      justAdded=false; itemsEl.innerHTML=''; emptyEl.hidden=false; foot.hidden=true; return;
    }
    emptyEl.hidden=true; foot.hidden=false;
    var orig=0; cart.items.forEach(function(it){orig+=it.original_line_price;});
    var origR=R(orig), totR=R(cart.total_price), savedR=origR-totR;

    var apps=[], seen={};
    (cart.cart_level_discount_applications||[]).forEach(function(a){apps.push(a.discount_application||a);});
    cart.items.forEach(function(it){(it.line_level_discount_allocations||[]).forEach(function(al){var d=al.discount_application,k=d.type+'|'+d.title;if(!seen[k]){seen[k]=1;apps.push(d);}});});
    apps.sort(function(x,y){return (x.type==='discount_code')-(y.type==='discount_code');});
    var base=orig, shown=0, hasExtra=false, bundlePct=0;
    var rows=apps.map(function(a,i){
      var pctApp=a.value_type==='percentage', amt=pctApp?base*parseFloat(a.value)/100:(a.total_allocated_amount||0);
      if(a.type!=='discount_code'&&pctApp) bundlePct=Math.round(parseFloat(a.value));
      base-=amt;
      var r=(i===apps.length-1)?savedR-shown:R(amt); shown+=r;
      var label=a.type==='discount_code'?(pctApp?'Extra '+parseFloat(a.value)+'% off ('+esc(a.title)+')':'Discount code '+esc(a.title)):esc(a.title);
      if((a.title||'').toUpperCase().indexOf('CREDIT')===0){hasExtra=true;label='Sign-up credit ('+esc(a.title)+')';}
      return '<div class="pa-cd-disc"><span>'+CHK+label+'</span><span>&minus;'+rand(r)+'</span></div>';
    }).join('');

    var added=justAdded?'<div class="pa-cd-added" role="status">'+CHK+'Added to your cart</div>':'';
    justAdded=false;
    itemsEl.innerHTML=added+cart.items.map(function(it,i){
      var line=i+1;
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="pa-cd-item-variant">'+esc(it.variant_title)+'</div>':'';
      var img=it.image?'<img class="pa-cd-img" src="'+it.image+'" alt="">':'<span class="pa-cd-img"></span>';
      var oR=R(it.original_line_price), nR=R(it.original_line_price*cart.total_price/orig);
      return '<div class="pa-cd-item">'+img+
        '<div><div class="pa-cd-item-title">'+esc(it.product_title)+'</div>'+vt+
        '<div class="pa-cd-qtyrow"><div class="pa-cd-qty"><button type="button" class="pa-cd-q" data-line="'+line+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease quantity">&minus;</button><span>'+it.quantity+'</span><button type="button" class="pa-cd-q" data-line="'+line+'" data-q="'+(it.quantity+1)+'" aria-label="Increase quantity">+</button></div>'+
        '<button type="button" class="pa-cd-remove pa-cd-q" data-line="'+line+'" data-q="0">Remove</button></div></div>'+
        '<div class="pa-cd-item-price">'+(nR<oR?'<s>'+rand(oR)+'</s>':'')+rand(nR)+'</div></div>';
    }).join('');

    $('pa-cd-subtotal').textContent=rand(origR);
    $('pa-cd-disc').innerHTML=rows;
    var credAmt=(cart.item_count>=3?600:(cart.item_count===2?400:200));
    $('pa-cd-nudge').innerHTML=hasExtra?'':'<button type="button" class="pa-cd-nudge" data-vgp-open><span>Claim your R'+credAmt+' credit: add your email</span><span>&rarr;</span></button>';
    $('pa-cd-total').textContent=rand(totR);
    var sp=origR?Math.round(savedR*100/origR):0;
    var how=(hasExtra&&bundlePct)?(bundlePct+'% off + credit'):sp+'% off';
    $('pa-cd-save').innerHTML=savedR>0?'<div class="pa-cd-save">You&#39;re saving '+rand(savedR)+' ('+how+')</div>':'';
  }

  function refresh(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var codes=(c.discount_codes||[]).map(function(d){return d.code;});
      if(recalced||!codes.length) return c; recalced=true;
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})}).then(function(r){return r.json();}).catch(function(){return c;});
    }).then(render);
  }
  function openWithData(){open(); itemsEl.innerHTML='<p style="padding:30px 0;text-align:center;color:#5C6B80">Loading...</p>'; emptyEl.hidden=true; refresh();}

  document.addEventListener('vgp:unlocked',function(){ if(isOpen()) refresh(); });
  document.addEventListener('click',function(e){
    var opener=e.target.closest('[data-cart-open]'); if(opener){e.preventDefault();openWithData();return;}
    if(e.target.closest('[data-cart-close]')){close();return;}
    var q=e.target.closest('.pa-cd-q');
    if(q){
      e.preventDefault(); itemsEl.style.opacity='.5';
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(q.getAttribute('data-line'),10),quantity:parseInt(q.getAttribute('data-q'),10)})})
        .then(function(r){return r.json();}).then(function(c){itemsEl.style.opacity='';render(c);}).catch(function(){itemsEl.style.opacity='';refresh();});
    }
  });

  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[action*="/cart/add"]'); if(!f) return;
    e.preventDefault(); var fd=new FormData(f), btn=f.querySelector('[type=submit]');
    if(btn){btn.dataset.t=btn.dataset.t||btn.innerHTML;btn.textContent='Adding...';}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd}).then(function(r){return r.json();}).then(function(){
      justAdded=true;
      if(btn){btn.textContent='Added';setTimeout(function(){btn.innerHTML=btn.dataset.t||'Add to cart';},1800);}
      openWithData();
    }).catch(function(){f.submit();});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return;
    var a=e.target.closest('a[href]'); if(!a||!VARIANT) return;
    if((a.getAttribute('href')||'').charAt(0)==='#') return;
    if(a.closest('footer,#pa-cd,form[action="/cart"],[data-no-add]')||a.hasAttribute('data-no-add')) return;
    var u; try{u=new URL(a.href,location.origin);}catch(x){return;}
    if(u.origin!==location.origin||u.pathname!==ALL) return;
    e.preventDefault();
    var samePage=(location.pathname===ALL), dest=a.href;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var has=(c.items||[]).some(function(it){return String(it.variant_id)===String(VARIANT);});
      if(has){ if(samePage){openWithData();} else {location.href=dest;} return; }
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:VARIANT,quantity:1}]})}).then(function(r){
        if(!r.ok) throw new Error('add failed');
        if(samePage){justAdded=true;openWithData();}
        else{try{sessionStorage.setItem('vg_open_cart','1');}catch(x){} location.href=dest;}
      });
    }).catch(function(){location.href=dest;});
  });
  try{ if(sessionStorage.getItem('vg_open_cart')){sessionStorage.removeItem('vg_open_cart');justAdded=true;openWithData();} }catch(x){}
})();